export const sources={};export const img={src:"__VITE_ASSET__AsHNVVn_Y92mmWEtoBC9VA__",w:640,h:640};export default{sources:sources,img:img};